import React from 'react';
import PageHero from '../components/PageHero';
import ContactForm from '../components/ContactForm';
import Footer from '../components/Footer';
import { contactInfo } from '../data/mock';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
import { Helmet } from "react-helmet";

const ContactPage = () => {
  const breadcrumbItems = [
    { label: 'HOME', path: '/' },
    { label: 'CONTACT' }
  ];

  return (
    <div className="page-wrapper">
      <PageHero 
        title="Get in Touch"
        breadcrumbItems={breadcrumbItems}
        subtitle="Let's discuss your manufacturing needs"
      />
      
      <section className="page-content-section">
        <div className="container-modern">
          <div className="contact-page-layout">
            <div className="contact-info-cards">
              <div className="contact-info-card">
                <MapPin className="contact-card-icon" />
                <h3 className="contact-card-title">Visit Us</h3>
                <div className="contact-card-content">
                  <p>{contactInfo.address.name}</p>
                  <p>{contactInfo.address.line1}</p>
                  <p>{contactInfo.address.line2}</p>
                  <p>{contactInfo.address.line3}</p>
                  <p>{contactInfo.address.city}</p>
                  <p>{contactInfo.address.state}</p>
                </div>
              </div>
              
              <div className="contact-info-card">
                <Phone className="contact-card-icon" />
                <h3 className="contact-card-title">Call Us</h3>
                <div className="contact-card-content">
                  <p>Phone: {contactInfo.phone}</p>
                  <p>WhatsApp: {contactInfo.whatsapp}</p>
                </div>
              </div>
              
              <div className="contact-info-card">
                <Mail className="contact-card-icon" />
                <h3 className="contact-card-title">Email Us</h3>
                <div className="contact-card-content">
                  <p>{contactInfo.email}</p>
                </div>
              </div>
              
              <div className="contact-info-card">
                <Clock className="contact-card-icon" />
                <h3 className="contact-card-title">Business Hours</h3>
                <div className="contact-card-content">
                  <p>Monday - Friday: 9:00 AM - 6:00 PM</p>
                  <p>Saturday: 10:00 AM - 4:00 PM</p>
                  <p>Sunday: Closed</p>
                </div>
              </div>
            </div>
            
            <div className="contact-page-text">
              <h2 className="contact-section-title">Why Choose Maverxx Innovations?</h2>
              <ul className="contact-benefits-list">
                <li>Tight dimensional tolerance control</li>
                <li>Engineering-focused approach</li>
                <li>Fast turnaround timelines</li>
                <li>Transparent communication</li>
                <li>Scalable from prototype to production</li>
                <li>Confidential & professional handling</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      
      <ContactForm />
      <Footer />
    </div>
  );
};

export default ContactPage;
